<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>

            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont" style="padding:10px;" v-show="Tagkod==-1">
                <b>A hivatkozási paraméterek elévültek!</b>
            </div>


            <div class="main_col_cont" v-show="Tagkod>0">

                <div class="infotext_div infotext" style="font-weight:500; margin:10px 0px; text-align:left;">Üdvözölünk {{Nev}}!</div>

                <div class="section_header" style="margin-bottom: 10px;"><i class="far fa-credit-card" style="margin-right:10px;"></i>Egészségpénztári kártya csodásítása</div>
                <div class="infotext_div infotext" v-html="csodasitas_infotext" style="margin-bottom: 10px;"></div>

                <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkCsodaFelt" /></td>
                    <td valign="top" class="infotext" style="text-align:left; font-weight:500;">
                        Beállítom a csodakártya szolgáltatást az egészségkártyás vásárláshoz és elfogadom a
                        <span style="text-decoration:underline; cursor:pointer;" @click="ShowCsodaFelt">feltételeket</span>.
                    </td>
                </tr>
                </table>        

                <!--
                <div class="section_header" style="margin-bottom: 10px;"><i class="fas fa-money-bill" style="margin-right:10px;"></i>Készpénzes vásárlás</div>
                <div class="infotext_div infotext" v-html="kp_infotext"></div>

                <div class="btn_cont" v-show="KpInfotext2Visible==0">
                    <div class="btn grc-noselect" @click="ShowKpInfotext2">
                        <i class="fas fa-info-circle btn_icon" style="margin-right:8px;"></i>Részletek
                    </div>
                </div>

                <div v-show="KpInfotext2Visible==1" class="infotext" v-html="kp_infotext2" style="margin-top:10px;"></div>
            
                <GrcNum ref="txtKPOSSZEG" v-model="txtKPOSSZEG" 
                grc_labeltext="Havi keretösszeg:" grc_labelmode="" grc_labelwidth="200px"
                grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                grc_textalign="left"
                style="margin-bottom:20px; max-width:300px; margin-top:20px;" />

                <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkKpFelt" /></td>
                    <td valign="top" class="infotext" style="text-align:left; font-weight:500;">
                        Beállítom a csodakártya szolgáltatást a készpénzes vásárláshoz és elfogadom a 
                        <span style="text-decoration:underline; cursor:pointer;" @click="ShowKpFelt">feltételeket</span>.
                    </td>
                </tr>
                </table>           
                --> 

                <div class="section_header" style="margin-bottom: 0px;"><i class="far fa-envelope" style="margin-right:10px;"></i>Értesítési beállítások</div>

                <div class="colcont">
                    <div class="colcont_col2">
                        <div class="infotext_div infotext" style="margin-top:20px; margin-bottom:10px;">
                            Az értesítőket erre a címre kérem küldeni:
                        </div>

                        <div style="width:100%; box-sizing:border-box; max-width:500px; margin-bottom:10px;">
                            <GrcText ref="EmailCim"
                            grc_labeltext="E-mail cím:" grc_labelmode="above" grc_labelwidth="80px" 
                            />
                        </div>
                    </div>
                    <div class="colcont_col2">
                        <div class="infotext_div infotext" style="margin-top:20px; margin-bottom:10px;">
                            Kérjük nevezd el a kártyádat (pl. OTP lakossági):
                        </div>

                        <div style="width:100%; box-sizing:border-box; max-width:500px; margin-bottom:10px;">
                            <GrcText ref="KartyaMegnevezes"
                            grc_labeltext="Megnevezés:" grc_labelmode="above" grc_labelwidth="80px" 
                            />
                        </div>
                    </div>
                </div>
                


                <div class="btn_cont" style="border-top: solid 2px var(--premblue); margin:20px 0px; text-align:center;padding-top:10px;">
                    <div class="btn grc-noselect" @click="PreparePayment">
                        <i class="fas fa-chevron-right btn_icon" style="margin-right:8px;"></i>Tovább a bankkártya regisztráláshoz
                    </div>
                </div>



            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcText from '../GrcComponents/GrcText.vue'


export default {
  name: 'frmCsodakartya',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      GrcNum,
      GrcText,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmCsodakartya",
            gPopupControlName:"",

            innerformid:0,
            title:"",
            csodasitas_infotext:"",
            csoda_feltetel:"",
            kp_infotext:"",
            KpInfotext2Visible:0,
            kp_infotext2:"",
            kp_feltetel:"",

            param_tagkod:0,
            param_ct:"",
            param_cv:"",
            Tagkod:0,
            Nev:"",

            txtKPOSSZEG:0,

            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmCsodakartya", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");
        this.csodasitas_infotext = this.GetTextBookItem("csodasitas_infotext");
        this.csoda_feltetel = this.GetTextBookItem("csoda_feltetel");
        this.kp_infotext = this.GetTextBookItem("kp_infotext");
        this.kp_infotext2 = this.GetTextBookItem("kp_infotext2");
        this.kp_feltetel = this.GetTextBookItem("kp_feltetel");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
      },

    ShowCsodaFelt()
    {
      this.ShowInfoDialog(this.csoda_feltetel, 800);

    },

    ShowKpInfotext2()
    {
      this.KpInfotext2Visible = 1;
    },

    ShowKpFelt()
    {
      this.ShowInfoDialog(this.kp_feltetel, 600);
    },

    async PreparePayment()
    {
        var EpKartyaCsodasitas = this.$refs.chkCsodaFelt.GetValue();
        var KpCsodasitas = 0; //this.$refs.chkKpFelt.GetValue();
        var KpOsszeg = 0; //this.$refs.txtKPOSSZEG.GetValue();
        var EmailCim = this.$refs.EmailCim.GetText();
        var KartyaMegnevezes = this.$refs.KartyaMegnevezes.GetText();

        var ErrorCompName = "";

        if (grcmain_IsValidEmailAddress(this.$refs.EmailCim.GetText()) == false)
        {
            if (ErrorCompName == "") { ErrorCompName = "EmailCim"; }
            if (this.$refs.EmailCim.GetText() == "")
            {
                this.$refs.EmailCim.ShowError("Az e-mail cím megadása kötelező!");
            }
            else
            {
                this.$refs.EmailCim.ShowError("Az e-mail cím formátuma helytelen!");
            }
        }
        
        if (this.$refs.KartyaMegnevezes.GetText() == "")
        {
            if (ErrorCompName == "") { ErrorCompName = "KartyaMegnevezes"; }
            this.$refs.KartyaMegnevezes.ShowError("A kártya megnevezés megadása kötelező!");
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        if ((KpCsodasitas == 0)&&(KpOsszeg>0))
        {
            var DialogResult = "";
            var infotext = "A készpénzes vásárlás havi keretösszegét megadtad, de a készpénzes szolgáltatást nem jelölted ki!<br><br>Szeretnéd aktiválni a csodakártyát a készpénzes vásárlás esetén is?";

            var p = grccomp_dialog_yesno_GetDefaults(grcmain_GetTextBookItem("tech", "megerosites"), infotext);             
            p.height = 300;
            p.width = 400;
            p.padding_top = 20;
            if (grccomp_getScreenSize().width < 400) { p.width = 300; }

            
            await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        

            if (DialogResult == "YES") { KpCsodasitas = 1; }
        }


        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            iTagkod: this.param_tagkod,
            sCreateTime: this.param_ct,
            sHash: this.param_cv,

            iEpKartyaCsodasitas: EpKartyaCsodasitas,
            iKpCsodasitas: KpCsodasitas,
            iKpOsszeg: KpOsszeg,
            sEmailCim: EmailCim,
            sKartyaMegnevezes: KartyaMegnevezes
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_PreparePayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.GRCDB.HideLoading();


        var SIMPLE_LIVEUPDATE_URL = Q.PAYMENT[0].SIMPLE_LIVEUPDATE_URL;
        var TIMEOUT_URL = Q.PAYMENT[0].PAYCENTER_TIMEOUT;
        var BACK_REF = Q.PAYMENT[0].PAYCENTER_BACKREF;

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = SIMPLE_LIVEUPDATE_URL;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "MERCHANT");
        myInput.setAttribute("id", "MERCHANT");
        myInput.setAttribute("value", Q.PAYMENT[0].MERCHANT);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_REF");
        myInput.setAttribute("id", "ORDER_REF");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_REF);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_DATE");
        myInput.setAttribute("id", "ORDER_DATE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_DATE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PNAME[]");
        myInput.setAttribute("id", "ORDER_PNAME");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PNAME);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PCODE[]");
        myInput.setAttribute("id", "ORDER_PCODE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PCODE);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PRICE[]");
        myInput.setAttribute("id", "ORDER_PRICE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PRICE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_VAT[]");
        myInput.setAttribute("id", "ORDER_VAT");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_VAT);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_QTY[]");
        myInput.setAttribute("id", "ORDER_QTY");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_QTY);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PRICES_CURRENCY");
        myInput.setAttribute("id", "PRICES_CURRENCY");
        myInput.setAttribute("value", "HUF");
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "TIMEOUT_URL");
        myInput.setAttribute("id", "TIMEOUT_URL");
        myInput.setAttribute("value", TIMEOUT_URL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "BACK_REF");
        myInput.setAttribute("id", "BACK_REF");
        myInput.setAttribute("value", BACK_REF);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "BILL_EMAIL");
        myInput.setAttribute("id", "BILL_EMAIL");
        myInput.setAttribute("value", Q.PAYMENT[0].BILL_EMAIL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_HASH");
        myInput.setAttribute("id", "ORDER_HASH");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_HASH);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PAY_METHOD");
        myInput.setAttribute("id", "PAY_METHOD");
        myInput.setAttribute("value", "CCVISAMC");
        myForm.appendChild(myInput);

        if (Q.PAYMENT[0].LU_ENABLE_TOKEN == "1")
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_ENABLE_TOKEN");
            myInput.setAttribute("id", "LU_ENABLE_TOKEN");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_ENABLE_TOKEN);
            myForm.appendChild(myInput);

            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_TOKEN_TYPE");
            myInput.setAttribute("id", "LU_TOKEN_TYPE");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_TOKEN_TYPE);
            myForm.appendChild(myInput);
        }


        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        


    },



    async Init()
    {
        this.Tagkod = 0;

        this.param_tagkod = 0;
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "csodakartya") && (GRCAPP_GetParameters.TAGKOD != "") && (GRCAPP_GetParameters.TAGKOD != undefined))
        {
            this.param_tagkod = parseInt(GRCAPP_GetParameters.TAGKOD);
            GRCAPP_GetParameters.TAGKOD = "";
        }

        this.param_ct = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "csodakartya") && (GRCAPP_GetParameters.CT != "") && (GRCAPP_GetParameters.CT != undefined))
        {
            this.param_ct = GRCAPP_GetParameters.CT;
            GRCAPP_GetParameters.CT = "";
        }

        this.param_cv = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "csodakartya") && (GRCAPP_GetParameters.CV != "") && (GRCAPP_GetParameters.CV != undefined))
        {
            this.param_cv = GRCAPP_GetParameters.CV;
            GRCAPP_GetParameters.CV = "";
        }

        if (this.param_tagkod == 0)
        {
            this.Tagkod = -1;
            return;
        }




        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            iTagkod: this.param_tagkod,
            sCreateTime: this.param_ct,
            sHash: this.param_cv
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }



        this.Tagkod = Q.DATA[0].Tagkod;
        this.Nev = Q.DATA[0].Nev;

        this.$refs.GRCDB.HideLoading();
        
    },


    
    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 800;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.infotext_div
{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0px;    
}

.infotext
{
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
}

.section_header
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:20px;
    line-height: 24px;
    font-weight:500;
    text-align: left;
    padding: 8px 0px;
    border-bottom: dotted 2px var(--premblue);
}


div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: left;
}

.btn
{
  display: inline-block;
  font-size: 14px;
  line-height: 14px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}


div >>> .btnLink
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;
}


div >>> .btnLink:visited
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;
}


div >>> .btnLink:hover
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premgreen);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;

}

.colcont
{
    width:100%;
    box-sizing: border-box;
}

.colcont_col2
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    padding-right:20px;
    vertical-align: top;
}



@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{

    .section_header
    {
        font-size:18px;
        line-height: 22px;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

    .colcont_col2
    {
        width:100%;
        padding:0px;
    }

}


</style>